module.exports = __webpack_public_path__ + "static/img/wealth.9def6132.png";